<template>
	<page>
		<module>
			<view-list ref="view" work-type="3" selector :view-config="auth('b_customer_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="客户编号">
							<c-input name="customer_code"></c-input>
						</m-search-item>
						<m-search-item label="客户名称">
							<c-input name="customer_name"></c-input>
						</m-search-item>
					</m-search>
				</template>
                <!--单据编号-->
                <template #customer_code="{data}">
                    <c-link @click="globalDialog('customerDetail', {props: {id: data.id}})">{{data.customer_code}}</c-link>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_customer_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_customer_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
				
				<c-table-column
					type="button"
					label="操作"
					width="130"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button icon="tf-edit" @click="globalDialog('customerDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_customer_sysuser')" icon="tf-edit" @click="$refs.customerSysuer.open({id: data.id})">客户账号</c-table-button>
					</template>
				</c-table-column>
			</view-list>
            <customer-sysuer ref="customerSysuer"></customer-sysuer>
		</module>
	</page>
</template>

<script>
    import customerSysuer from "@/pages/basic/customer_sysuser.vue";
	import {mapState} from 'vuex'
	export default {
        components: {
            customerSysuer
        },
		computed: {
			// 获取dictName选项数据
			...mapState(['openCloseDic'])
		},
		
		data() {
			return {
			}
		},
		
		methods: {

		}
	}
</script>

<style lang="stylus" scoped>
</style>